import { ContainerStatusEnum } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { Container } from '../container.entity';
import { BookContainerDto } from './book-container.dto';
import { DispatchedToPlant } from './container-dispatched-to-plant.dto';
import { ContainerDTO } from './container.dto';

@Injectable()
export class ContainerAdapter {
  /**
   * 
   * @param containerDto 
   * @param isUpdate 
   * @returns 
   */
  // public convertDtoToEntity(  containerDto: ContainerDTO,  isUpdate: boolean = false ): Container {
  //   const container = new Container();
  //   container.containerId=containerDto.containerId;
  //   container.containerNumber=containerDto.containerNumber;
  //   container.soNumber=containerDto.soNumber;
  //   container.lineSeal=containerDto.lineSeal;
  //   container.eSeal=containerDto.eSeal;
  //   container.containerStatus=containerDto.containerStatus;
  //   container.loadingDate=containerDto.loadingDate;
  //   container.actualDate=containerDto.actualDate;
  //   container.vehicleNumber=containerDto.vehicleNumber;
  //   container.driverName=containerDto.driverName;
  //   container.phoneNumber=containerDto.phoneNumber;
  //   container.assignedBy=containerDto.assignedBy;
  //   container.isActive=containerDto.isActive==undefined?true:containerDto.isActive;
  //   if (isUpdate) {
  //       container.updatedUser = containerDto.updatedUser;
  //   } else {
  //       container.isActive = true;
  //       container.createdUser = containerDto.createdUser;
  //   }
  //  return container;
  // }
  // public convertEntityToDto(containerObject: Container): ContainerDTO {
  //   const containerDto= new ContainerDTO;
  //   containerDto.containerId=containerObject.containerId;
  //   containerDto.containerNumber=containerObject.containerNumber;
  //   containerDto.soNumber=containerObject.soNumber;
  //   containerDto.lineSeal=containerObject.lineSeal;
  //   containerDto.eSeal=containerObject.eSeal;
  //   containerDto.containerStatus=containerObject.containerStatus;
  //   containerDto.loadingDate=containerObject.loadingDate;
  //   containerDto.actualDate=containerObject.actualDate;
  //   containerDto.vehicleNumber=containerObject.vehicleNumber;
  //   containerDto.driverName=containerObject.driverName;
  //   containerDto.phoneNumber=containerObject.phoneNumber;
  //   containerDto.assignedBy=containerObject.assignedBy;
  //   containerDto.isActive = containerObject.isActive;
  //   containerDto.createdAt = containerObject.createdAt;
  //   containerDto.updatedAt = containerObject.updatedAt;
  //   containerDto.createdUser = containerObject.createdUser;
  //   containerDto.updatedUser = containerObject.updatedUser;
  //   containerDto.versionFlag = containerObject.versionFlag;
  //   return containerDto;
  // }

  public convertBookingDtoToEntity(containerInfo:BookContainerDto):Container{
    const container = new Container();
    container.expectedDeliveryDate = containerInfo.expectedDeliveryDate;
    container.referenceNumber = containerInfo.referenceNumber;
    container.saleOrderId = containerInfo.saleOrderId;
    container.scac = containerInfo.scac;
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
      container.updatedUser = containerInfo.updatedUser;
    }else{
      container.createdUser = containerInfo.createdUser;
    }
    container.containerStatus = ContainerStatusEnum.BOOKED;
    container.unitId = containerInfo.unitId;
    return container;
  }

  public convertDispatchToPlantDtoToEntity(containerInfo:DispatchedToPlant):Container{
    const container = new Container();
    container.containerNumber = containerInfo.containerNumber;
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
    }
    return container;
  }
  public convertFillSealInfoDtoToEntity(containerInfo:ContainerDTO):Container{
    const container = new Container();
    container.loadingDate= containerInfo.loadingDate;
    container.containerNumber = containerInfo.containerNumber;
    container.phoneNumber=containerInfo.phoneNumber;
    container.vehicleNumber=containerInfo.vehicleNumber
    container.lineSeal=containerInfo.lineSeal;
    container.eSeal=containerInfo.eSeal;
    if(containerInfo.containerId){
      container.containerId = containerInfo.containerId;
    }
    return container;
  }
}
